import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/cycle-api';

import { useFormState } from '../../../../hooks/useFormState';

import { STAGE_TYPE_OPTIONS } from '../../../../constants/cycleDetail';
import { defaultErrorMessage } from '../../../../constants/errorMessages';

import Modal from '../../../../design-system/Modal/Modal';
import ErrorAlert from '../../../../design-system/ErrorAlert/ErrorAlert';
import ModalHeader from '../../../../design-system/ModalHeader/ModalHeader';
import { Button, Select } from '../../../../design-system';

const NewStageModal = ({ cycleId, setStages, onClose }) => {
    const { formData, handleInputChange } = useFormState({ type: null });

    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleCreateStage = async () => {
        if (!formData.type) return;

        try {
            setIsLoading(true);
            const requestBody = { cycle: cycleId, type: formData.type };

            const { data } = await client.post(API.ROUTES.cycle.cycleStage, requestBody);

            setStages((prev) => [...(prev || []), data]);
            onClose();
        } catch (e) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        } finally {
            setIsLoading(false);
        }
    };

    const submitButtonState = isLoading ? 'loading' : !formData.type ? 'disabled' : 'default';

    return (
        <Modal size="medium" resetPadding onClose={onClose}>
            <ModalHeader title="New Stage" outlined onClose={onClose} />

            <div className="px-5 sm:px-6 md:px-8 py-5 flex flex-col gap-4">
                <Select
                    name="stage_type"
                    size="xs"
                    options={STAGE_TYPE_OPTIONS}
                    value={formData.type}
                    label="Stage Type"
                    isRequired
                    onChange={(type) => handleInputChange('type', type)}
                    placeholder="Select a stage type"
                    dropdownHeight={234}
                    increaseComponentHeightBy={172}
                    disableSorting
                />

                <div className="flex items-center justify-between gap-3">
                    <Button type="neutral" size="md" text="Cancel" onClick={onClose} />
                    <Button
                        type="secondary"
                        size="md"
                        text="Create"
                        state={submitButtonState}
                        onClick={handleCreateStage}
                    />
                </div>
            </div>

            <ErrorAlert errorAlert={errorAlert} setErrorAlert={setErrorAlert} />
        </Modal>
    );
};

export default NewStageModal;
